import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GameCardBase, GC_BASE_CSS } from '@/src/app/uygulamalar/hmi-pano/pano/game-card-base';

const KAT_RENK: Record<string, string> = { 'Bilgi': '#3b82f6', 'Uyarı': '#f59e0b', 'Kritik': '#ef4444' };
const KAT_RGB: Record<string, string> = { 'Bilgi': '59,130,246', 'Uyarı': '245,158,11', 'Kritik': '239,68,68' };

@Component({
  selector: 'proje-notu-kart',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="gc gc--proje-notu" [style.--accent]="katRenk()" [style.--accent-rgb]="katRgb()" (mousemove)="mouseMove($event)" (mouseleave)="mouseLeave()" [ngStyle]="kartStil">
      <div class="gc-canli-bg"></div><div class="gc-parlak-kenar"></div>
      <div class="gc-kose gc-kose--sol-ust"></div><div class="gc-kose gc-kose--sag-ust"></div><div class="gc-kose gc-kose--sol-alt"></div><div class="gc-kose gc-kose--sag-alt"></div>
      <div class="gc-kose-ic gc-kose-ic--sol-ust"></div><div class="gc-kose-ic gc-kose-ic--sag-ust"></div><div class="gc-kose-ic gc-kose-ic--sol-alt"></div><div class="gc-kose-ic gc-kose-ic--sag-alt"></div>
      <div class="gc-rarity-serit"></div><div class="gc-ic-glow"></div><div class="gc-desen"></div><div class="gc-shimmer"></div><div class="gc-holo"></div>
      <div class="gc-kenar-glow" [style.background]="kenarGlow"></div>
      <div class="gc-parcaciklar"><span class="gc-p gc-p--buyuk" style="--d:9s;--x:18%;--y:28%"></span><span class="gc-p" style="--d:12s;--x:72%;--y:42%"></span><span class="gc-p gc-p--kucuk" style="--d:5s;--x:48%;--y:72%"></span></div>
      <div class="gc-icerik">
        <div class="gc-hud-baslik">PROJE NOTU</div>
        <div class="pn-ust">
          <div class="pn-kategori-badge">{{ p()?.kategori || 'Bilgi' }}</div>
          <div class="pn-baslik gc-baslik-ana">{{ p()?.baslik || 'Not' }}</div>
        </div>
        @if (p()?.icerik) { <div class="pn-icerik">{{ p().icerik }}</div> }
        <div class="gc-xp-bar"><div class="gc-xp-dolgu" [style.width.%]="gorunur() ? 45 : 0"></div></div>
      </div>
    </div>
  `,
  styles: [GC_BASE_CSS, `
    .gc { --accent: #8b5cf6; --accent-rgb: 139,92,246; }
    .pn-ust { display: flex; align-items: center; gap: 8px; }
    .pn-kategori-badge { font-size: 8px; font-weight: 700; letter-spacing: .08em; text-transform: uppercase; padding: 2px 8px; border-radius: 2px; color: #fff; background: var(--accent); flex-shrink: 0; animation: badge-pulse 2s ease-in-out infinite; }
    .pn-baslik { font-size: 13px; font-weight: 700; color: var(--py-metin, #e2e8f0); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .pn-icerik { font-size: 10px; color: var(--py-metin-ikincil, #64748b); line-height: 1.4; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
  `],
})
export class ProjeNotuKartComponent extends GameCardBase {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  katRenk = computed(() => KAT_RENK[this.p()?.kategori] || '#3b82f6');
  katRgb = computed(() => KAT_RGB[this.p()?.kategori] || '59,130,246');
}
